<template>
  <div :class="className ? className : 'food-mark-element-bottom'" v-if="showFoodMark">
    <span class="isEgg foodMark egg-mark" :title="title" v-if="isEgg"></span>
    <span class="isVeg foodMark veg-mark" :title="title" v-if="isVeg"></span>
    <span class="foodMark nonveg-mark" :title="title" v-else></span>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    className: {
      type: String,
      default: 'food-mark-element-bottom',
    },
    isVeg: {
      type: Boolean,
      default: true,
    },
    isEgg: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
    };
  },
  computed: {
    ...mapGetters([
        "SHOW_VEG_NONVEG_lOGO"
    ]),
    showFoodMark() {
        let status = true;
        if(this.SHOW_VEG_NONVEG_lOGO == 'N') {
            status = false;
        } 
        else {
            status = true;
        }
        return status;
    }
  },
};
</script>

<style>

.food-mark-element-bottom {
    /* position: absolute; */
    right: 0px; /*8px */
    /* bottom: 0px; */ 
    display: flex;
    padding-right:20px;
    /* flex-direction: column; */
    align-items: center;
}

.food-mark-element-top {
    position: absolute;
    right: 3px;
    top: 3px;
    display: inline-flex;
}

.food-mark-element-inline {
    height: 28px;
}
 @media screen and (min-width:100px) and (max-width:1200px) {

 }
</style>



// WEBPACK FOOTER //
// src/components/UIElements/VegMark.vue